import { Modal } from "react-bootstrap";

interface IPhotoZoomProps {
    source: string;
    isOpen: boolean;
    handleClose: () => void;
    onNextPress: () => void;
    onPreviousPress: () => void;
}

const PhotoZoom = (props: IPhotoZoomProps) => {
    return (
        <Modal show={props.isOpen}
            onHide={props.handleClose}
            contentClassName="zoomed-photo-modal-body"
            centered
            size="lg">
            <svg xmlns="http://www.w3.org/2000/svg" onClick={props.handleClose} width="24" height="24" fill="black" className="bi bi-x-lg margin-8 margin-left-auto " viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
            </svg>
            <Modal.Body className="zoomed-photo-modal-body d-flex">
                <div className="modal-body d-flex justify-content-center" style={{ maxWidth: 800, maxHeight: 800 }}>
                    <img alt={"student-photo-zoom"} src={props.source} className="zoomed-photo" />
                </div>
            </Modal.Body>
            <Modal.Footer className="zoomed-photo-modal-body zoomed-photo-modal-footer">
                <svg onClick={props.onPreviousPress} xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-arrow-left margin-8" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                </svg>
                <svg onClick={props.onNextPress} xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-arrow-right margin-8" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg>
            </Modal.Footer>
        </Modal>
    );
}

export default PhotoZoom;